import { InfoOutlined } from '@mui/icons-material';
import { ToggleButton, ToggleButtonGroup, Tooltip, Typography, alpha } from '@mui/material';
import { WidgetProps } from '@rjsf/utils';
import { useState } from 'react';

type ToggleButtonWidgetSettings = {
  icons?: Record<string, JSX.Element>;
  disabledOptions?: string[];
  descriptions?: Record<string, string>;
};

const ToggleButtonWidget = (props: WidgetProps<ToggleButtonWidgetSettings>) => {
  const options = props.options?.enumOptions || [];
  const settings = props.options as ToggleButtonWidgetSettings;
  const icons = settings?.icons || {};
  const disabledOptions = settings?.disabledOptions || [];
  const descriptions = settings?.descriptions || {};
  const [value, setValue] = useState(props.value || props.schema.default);

  const handleChange = (_: React.MouseEvent<HTMLElement>, newValue: string) => {
    if (newValue !== null) {
      setValue(newValue);
      props.onChange(newValue);
    }
  };

  return (
    <>
      <Typography variant="subtitle1">{props.label}</Typography>
      <ToggleButtonGroup
        exclusive
        value={value}
        onChange={handleChange}
        color="primary"
        disabled={props.disabled}
        sx={(theme) => ({
          mt: 1,
          mb: 2,
          '& .MuiToggleButton-root.Mui-selected': {
            color: theme.palette.accent.main,
            backgroundColor: alpha(theme.palette.accent.main, 0.16),
            '&:hover': { backgroundColor: alpha(theme.palette.accent.main, 0.24) },
          },
        })}
      >
        {options.map((option) => (
          <ToggleButton
            value={option.value}
            disabled={props.disabled || disabledOptions.includes(option.value)}
            className="flex gap-1"
          >
            {icons[option.value] || null}
            {option.label}
            {option.value in descriptions && (
              <Tooltip title={descriptions[option.value]}>
                <InfoOutlined fontSize="inherit" />
              </Tooltip>
            )}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </>
  );
};

export default ToggleButtonWidget;
